<template>
  <div class="overflow-auto">
    <div v-if="data && data.length > 0">
      <div class="px-3 py-1 mb-0 mt-3" v-for="item in data">
        <div class="d-flex align-items-center">
          <div class="px-3 d-flex flex-column">
            <div class="fz-16 fw-700 d-flex">
              <span class="mr-2">{{ item.payeeAccountName }}</span>
              <div :class="'ml-auto badge-default badge-' + item.status.toLowerCase()
                ">
                {{
                  $t(item.status.charAt(0).toUpperCase() + item.status.slice(1))
                }}
              </div>
            </div>
            <div class="fz-14 fw-700 text-grey7">{{ item.payeeUserNo }}</div>
          </div>
          <div class="px-3 ml-auto d-flex flex-column">
            <div class="fz-14 fw-700">
              {{ item.fundType == "in" ? "+" : "-" }} {{ item.payerCcy }}
              {{ getPrice(parseFloat(item.payerAmt)) }}
            </div>
            <div class="fz-14 fw-400 text-grey7">{{ item.updated_at }}</div>
          </div>
        </div>
        <hr />
      </div>
    </div>
    <div v-else class="text-center p-4 fz-20 text-grey7 fw-500">
      {{ $t("No history found") }}
    </div>

    <div v-if="isLoading" class="dot-loading mt-3">
      <ul class="loader-circle">
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>
  </div>
</template>

<script>
import Account from "@/services/Account";
import CreateAccount from "@/services/CreateAccount";
import Transfer from "../services/Transfer";
import Global from "@/services/Global";
import moment from "moment";

const STATUS = {
  1: "Pending",
  2: "Pending",
  3: "Approved",
  4: "Rejected",
};

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL !== "/" ? process.env.BASE_URL : "",
      isLoading: false,
      data: [],
      payeeList: [],
      search: "",
    };
  },
  props: ["type"],
  methods: {
    getPrice(amount) {
      return Global.addCommas(amount);
    },

    transferList(user_no) {
      let self = this;

      if (this.type == "transfer") {
        Transfer.transferList({
          userNo: user_no,
        }).then((response) => {
          if (response.status == 200) {
            self.data = response.data.data;
            self.data.forEach((item, index) => {
              self.data[index].payeeAccountName = item.recepient.payee_name;

              let userNo = item.payeeUserNo.match(/.{1,4}/g);
              for (let index = 0; index < userNo.length; index++) {
                if (index < userNo.length - 2) {
                  userNo[index] = "****";
                }
              }

              self.data[index].fundType =
                user_no == item.payeeUserNo ? "in" : "out";
              self.data[index].payeeUserNo = userNo.join(" ");
              self.data[index].updated_at = moment(item.updated_at).format(
                "DD MMMM YYYY HH:mm:ss"
              );

              self.data[index].status = STATUS[item.status];
            });
          }
        });
      }

      if (this.type == "consolidation") {
        Account.transferList({
          userNo: user_no,
        }).then((response) => {
          if (response.status == 200) {
            self.data = response.data.data;
            self.data.forEach(function (item, index) {
              for (let j = 0; j < self.payeeList.length; j++) {
                const payee = self.payeeList[j];
                if (item.payeeUserNo == payee.id) {
                  self.data[index].payeeAccountName = payee.accountName;
                }

                let userNo = item.payeeUserNo.match(/.{1,4}/g);
                for (let index = 0; index < userNo.length; index++) {
                  if (index < userNo.length - 2) {
                    userNo[index] = "****";
                  }
                }
                self.data[index].fundType =
                  user_no == item.payeeUserNo ? "in" : "out";
                self.data[index].payeeUserNo = userNo.join(" ");
                self.data[index].updated_at = moment(item.updated_at).format(
                  "DD MMMM YYYY HH:mm:ss"
                );
                self.data[index].status = STATUS[item.status];
              }
            });
          }
        });
      }
    },
    getData() {
      let self = this;
      CreateAccount.list({
        search: self.search,
        start: 0,
        length: -1,
      }).then((response) => {
        if (response.status == 200) {
          const data = response.data.data[0];
          self.transferList(data.userNo);
        }
      });
    },
    doSearch() { },
    handleViewSubAccount(id, userType) {
      this.$router.push({
        path: "/list-sub-account",
        query: {
          account_id: id,
          user_type: userType,
        },
      });
    },
    handleSubAccount(data) {
      this.$emit("sub-account", data);
    },
    checkError(err) {
      const response = err.response;
      try {
        if (response.status == 401 && response.data.name == "Unauthorized") {
          localStorage.removeItem("token");
          localStorage.removeItem("member");
          localStorage.removeItem("isFirstTime");
          this.$router.push({
            path: "/login",
          });
        } else {
          if (localStorage.getItem("token")) {
            var msg = response.data ? response.data.message : err.message;
            this.$notify({
              type: "warn",
              text: msg,
            });
          }
        }
      } catch (e) {
        console.log(err);
      }
    },
  },
  mounted() {
    let self = this;
    this.$nextTick(() => {
      Account.listPayee().then((response) => {
        if (response.status == 200) {
          const data = response.data.data;
          data.forEach(function (item) {
            self.payeeList.push({
              id: item.relationship_userNo,
              text: item.accountName + " - " + item.relationship_userNo,
              accountName: item.accountName,
            });
          });
          self.getData();
        }
      });
    });
  },
  destroyed() { },
};
</script>

<style scoped>
.block-account {
  background: #f8f9fa;
  border-radius: 8px;
}
</style>
